import React from 'react';
import { Link } from 'react-router-dom';
import './GuaranteeSection.css';

function GuaranteeSection() {
    return (
        <section className="guarantee-section">
            <div className="guarantee-content">
                <h2>Защо да ни се доверите?</h2>
                <div className="guarantee-grid">
                    <div className="guarantee-item">
                        <h3>Гарантирано качество</h3>
                        <p>Изработени от PU материал, тествани за издръжливост при интензивна употреба.</p>
                    </div>
                    <div className="guarantee-item">
                        <h3>14 дни право на връщане</h3>
                        <p>Ако не сте доволни, върнете продукта в оригинална опаковка в рамките на 14 дни.</p>
                    </div>
                    <div className="guarantee-item">
                        <h3>Безплатна доставка</h3>
                        <p>При поръчка на 2 или повече продукта доставяме безплатно до 2 работни дни.</p>
                    </div>
                </div>
                <Link to="/#product" className="guarantee-cta">Виж продукта</Link>
            </div>
        </section>
    );
}

export default GuaranteeSection;
